/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductServiceDetailsResponse
 */
export interface ProductServiceDetailsResponse {
    /**
     * Account number - 8 digits with leading zeros (0) if less than 8 digits
     * @type {string}
     * @memberof ProductServiceDetailsResponse
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceDetailsResponse
     */
    portfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceDetailsResponse
     */
    profile?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductServiceDetailsResponse
     */
    investmentAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceDetailsResponse
     */
    portfolioCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceDetailsResponse
     */
    bookingCenter?: string;
}

/**
 * Check if a given object implements the ProductServiceDetailsResponse interface.
 */
export function instanceOfProductServiceDetailsResponse(value: object): value is ProductServiceDetailsResponse {
    return true;
}

export function ProductServiceDetailsResponseFromJSON(json: any): ProductServiceDetailsResponse {
    return ProductServiceDetailsResponseFromJSONTyped(json, false);
}

export function ProductServiceDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductServiceDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'portfolio': json['portfolio'] == null ? undefined : json['portfolio'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'investmentAmount': json['investmentAmount'] == null ? undefined : json['investmentAmount'],
        'portfolioCurrency': json['portfolioCurrency'] == null ? undefined : json['portfolioCurrency'],
        'bookingCenter': json['bookingCenter'] == null ? undefined : json['bookingCenter'],
    };
}

export function ProductServiceDetailsResponseToJSON(json: any): ProductServiceDetailsResponse {
    return ProductServiceDetailsResponseToJSONTyped(json, false);
}

export function ProductServiceDetailsResponseToJSONTyped(value?: ProductServiceDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'portfolio': value['portfolio'],
        'profile': value['profile'],
        'investmentAmount': value['investmentAmount'],
        'portfolioCurrency': value['portfolioCurrency'],
        'bookingCenter': value['bookingCenter'],
    };
}

